/**
 * Dashboard api for the home page
 */

import Dashboard from "./dashboard";
// import Qs from "qs";

export default class TransactionsAPI extends Dashboard {
  constructor() {
    super();
  }

  encodeDataToURL = (params) => {
    let urlVals = Object.keys(params)
      .map((value) => `${value}=${encodeURIComponent(params[value])}`)
      .join("&");
    return urlVals;
  };

  getTransactions(context) {
    console.log(context);
    // return this.api.get('/transactionsTransactions', {
    let accessToken = localStorage.getItem("accessToken");
    let accessUser = localStorage.getItem("accessUser");

    let params = {
      eventId: context.eventId,
      startTime: context.searchStartTime,
      endTime: context.searchEndTime,
      stallholders: context.searchStallholders,
      stalls: context.searchStalls,
    };

    params = {
      eventId: "00000000000000C8",
      stallholderId: "00000000000000DP",
      stallId: "00000000000000SM",
      terminalNumber: 247,
      deviceId: "22418700",
      stan: "008299",
      TotalAmount: 15.5,
    };

    // console.log('PARAMS CHECK: ', params)
    let newParams = this.encodeDataToURL(params);

    return this.api
      .get(
        "/components/transactions?user=" +
          accessUser +
          "&accessToken=" +
          accessToken +
          "&" +
          newParams
        // {
        //   params: {
        //     eventId: context.eventId,
        //     startTime: context.searchStartTime,
        //     endTime: context.searchEndTime,
        //     stallholders: context.searchStallholders,
        //     stalls: context.searchStalls,
        //   },
        //   paramsSerializer: params => {
        //     return Qs.stringify(params, {arrayFormat: 'repeat'})
        //   }
        // }
      )
      .then((response) => {
        return response.data;
      });

    // return this.api
    //   .get("/transactions", {
    //     params: {
    //       eventId: "00000000000000C8",
    //       stallholderId: "00000000000000DP",
    //       stallId: "00000000000000SM",
    //       terminalNumber: 247,
    //       deviceId: "22418700",
    //       stan: "008299",
    //     },
    //     paramsSerializer: (params) => {
    //       return Qs.stringify(params, { arrayFormat: "repeat" });
    //     },
    //   })
    //   .then((response) => {
    //     return response.data;
    //   });
  }
}
